import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ProviderVM } from "@shared-kernel/application/ports/provider/provider-repository";

export const retrieveProviderProfile = createAsyncThunk<ProviderVM, void, { extra: Partial<Dependencies> }>(
  "providers/retrieveProviderProfile",
  async (_: void, { extra: { providerRepository } }) => {
    return providerRepository!.profile();
  },
);
